<script>
  import {External, M} from "../../external";

  export let data, filter, change;
  $: {
    if (!filter.func) filter.func = "moreThan";
    if ((filter.func === "moreThan" || filter.func === "exactly" || filter.func === "lessThan") && External.WebPlatform.parse(filter.value, 0) > 9000) {
      filter.value = '';
      onChange();
    }
  }

  let onChange = () => {
    change(filter);
  };
</script>

{#each data as item (item)}
  <div class="col20 f-left func-option" class:active={item.func === filter.func} data-role={item.func}>
    <label>
      <input type="radio" name="option" on:change={onChange} value={item.func} bind:group={filter.func} />
      <span>{item.name}</span>
    </label>
    {#if item.func === filter.func}
      <div class="col20 f-left option-value">
        <input on:keyup={onChange} type="number" name="value" min="0" max="1095" step="1" bind:value={filter.value} />
        <span>{M.CRM_DAYS_AGO_RIGHT}</span>
      </div>
    {/if}
  </div>
{/each}
